import { render, staticRenderFns } from "./SnackbarAlertComponent.vue?vue&type=template&id=6151efeb&scoped=true&"
import script from "./SnackbarAlertComponent.vue?vue&type=script&lang=ts&"
export * from "./SnackbarAlertComponent.vue?vue&type=script&lang=ts&"
import style0 from "./SnackbarAlertComponent.vue?vue&type=style&index=0&id=6151efeb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6151efeb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VImg,VSnackbar})
